<template>
  <b-modal
    id="save-modal"
    size="s"
    :title="
      !rename 
        ? $t('portfolioManager.savePortfolio.saveAs', { item: saveModalItem !== null ? saveModalItem.type : ''})
        : $t('portfolioManager.savePortfolio.renamePortfolio')
    "
    cancel-variant="primary"
    ok-variant="secondary"
    :ok-title="!rename ? $t('portfolioManager.savePortfolio.save') : $t('portfolioManager.savePortfolio.rename')"
    :cancel-title="$t('portfolioManager.savePortfolio.cancel')"
    :ok-disabled="!name"
    centered
    @ok="handleOkSumbit"
    @hide="handleClose"
  >
    <p v-if="saveModalItem !== null && saveModalItem.type === PORTFOLIO">
      {{ $t("portfolioManager.savePortfolio.hint") }}
    </p>
    <p v-if="saveModalItem !== null && saveModalItem.type === POOL">
      {{ $t("portfolioManager.savePortfolio.hintPool") }}
    </p>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(handleSavePortfolio)"
        name="saveNameForm"
      >
        <ValidationProvider
          v-slot="{ failed, errors }"
          :rules="{
            required: true,
            regex: /^[^\[\]:\*\?\\\/]+$/,
          }"
          name="portfolioName"
        >
          <SimpleFormInput
            v-model="name"
            :label="$t('portfolioManager.savePortfolio.inputLabel')"
            :hasError="failed"
            :helperText="errors[0]"
          />
        </ValidationProvider>
      </form>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import { POOL, PORTFOLIO, RENAME_PORTFOLIO } from "../../utils/constants";
import { mapGetters, mapMutations } from "vuex";
import SimpleFormInput from "../inputs/SimpleFormInput.vue";
export default {
  name: "save-portfolio-modal",
  components: { SimpleFormInput },
  data() {
    return {
      POOL,
      PORTFOLIO,
      RENAME_PORTFOLIO,
      name: "",
    };
  },
  computed: {
    ...mapGetters("portfolioManagerStore", ["saveModalItem"]),
    rename(){
      if(this.saveModalItem !== null && this.saveModalItem.type === RENAME_PORTFOLIO){
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations("portfolioManagerStore", ["setSaveModalItem"]),
    getParams() {
      const params = {};
      params[this.saveModalItem.type] = this.name;
      return params;
    },
    handleSavePortfolio() {
      this.$emit("saveItem", this.getParams());
      this.$root.$emit("bv::hide::modal", "save-modal");
      this.setSaveModalItem(null);
    },
    handleOkSumbit() {
      this.$emit("saveItem", this.getParams());
      this.setSaveModalItem(null);
    },
    handleClose() {
      setTimeout(() => {
        this.name = "";
        this.$emit("close");
      }, 3000);
    },
  },
};
</script>

<style>
</style>